<template>
    <div class="head-list-content">
        <HeadListNav :nav="sonNav"></HeadListNav>
    </div>
</template>

<script>
// import HeadListContent from '@/components/HeadListContent.vue'
import HeadListNav from "./HeadListNav.vue"
export default {
    name:'HeadListContent',
    data(){
        return{

        }
    },
    components:{
        HeadListNav
    },
    props:[
        'sonNav'
    ]
}
</script>

<style scoped>
    .head-list-content{
        width: 95%;
        /* min-height: 300px; */
        margin: auto;
    }
</style>
